import React, { Fragment } from 'react';

import FormDialogPeriodicExamination from './FormDialogPeriodicExamination';
import ListPeriodicExamination from './List';

export default function PeriodicExamination() {
  return (
    <Fragment>
      <ListPeriodicExamination />
      <FormDialogPeriodicExamination />
    </Fragment>
  );
}
